/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { FieldInputProps, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Label } from '../Label';
import styles from '../forms.module.css';

interface TextProps {
    label: string;
    id: string;
    name: string;
    placeholder?: string;
    required?: boolean;
    fullWidth?: boolean;
    hideLabel?: boolean;
    disabled?: boolean;
    autoComplete?: boolean;
    style?: React.CSSProperties;
    hideError?: boolean;
    onBlur?: (stuff: any, field: any) => void;
    onChange?: (stuff: any, field: any) => void;
}

export const Text: React.FC<TextProps> = ({
    id,
    label,
    required = false,
    fullWidth = false,
    hideLabel = false,
    disabled = false,
    autoComplete = false,
    placeholder,
    style = {},
    hideError,
    onBlur,
    onChange,
    ...props
}) => {
    const { t } = useTranslation(['common']);
    const [field, meta] = useField(props);

    const inputPlaceholder = placeholder || label || field?.name || '';

    const formatPlaceholder = (): string => (required ? `${inputPlaceholder} (${t('common:required')})` : inputPlaceholder);

    const handleBlur = (field: FieldInputProps<any>, e: React.FormEvent<HTMLInputElement>) => {
        if (onBlur) onBlur(field, e);

        field.onBlur(e);
    };

    const handleChange = (field: FieldInputProps<any>, e: React.FormEvent<HTMLInputElement>) => {
        if (onChange) onChange(field, e);

        field.onChange(e);
    };

    return (
        <>
            <Label label={label} hideLabel={hideLabel} id={id} required={required} />
            <input
                {...field}
                className={styles.InputElement}
                type="text"
                placeholder={formatPlaceholder()}
                disabled={disabled}
                style={{
                    width: fullWidth ? '100%' : 'auto',
                    borderLeft: required && hideLabel ? '2px solid var(--color-DarkGrey)' : '',
                    ...style,
                }}
                onBlur={(e) => handleBlur(field, e)}
                onChange={(e) => handleChange(field, e)}
                data-qa={`form-input-text-${field.name}`}
                autoComplete={autoComplete ? 'on' : 'off'}
            />
            {!hideError && meta.touched && meta.error && (
                <div className={styles.Error}>
                    <span>{meta.error}</span>
                </div>
            )}
        </>
    );
};
